Ext.define('SA.AcsTable.TableSearchField', {
    alias: 'widget.acs-table-search-field',
    extend: 'Ext.Component',

    cls: 'sa-acs-table-search-field',

    html: [
        '<input class="sa-acs-table-search-field-input">',
        '<button aria-label="clear" class="sa-acs-table-search-field-clear-btn">',
            '<svg aria-hidden="true" class="sa-acs-table-search-field-clear-btn-svg"><use href="#sa-icon-clear"></use></svg>',
        '</button>'
    ]
});
